import React from 'react'

const ThankYou = () => {
  return (
    <>
        <section className='thank-you-wrap'>
            <div className='container'>
                <div className='thank-you-block text-center text-white'>
                    <h1 className='lg-title text-center mb-4 font-2-5em'>Thank You for Reaching Out</h1>
                    <p className='font-1-3em'>Our friendly staff with reach out to you shortly.<br/>
                    If you have a more urgent request feel free to call us anytime at (954) 946-3000.<br/>
                    We look forward to talking with you very soon.</p>
                </div>
            </div>
        </section>
    </>
  )
}

export default ThankYou